var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution-privacy-changer" },
    [
      _c("a-alert", {
        staticClass: "mb-4",
        attrs: {
          type: "info",
          "show-icon": "",
          message: _vm.$t("automation.executionPrivacyTitle"),
          description: _vm.$t("automation.executionPrivacyDescription"),
        },
      }),
      _vm._v(" "),
      _vm.getIsPublic()
        ? _c("a-alert", {
            attrs: {
              type: "info",
              "show-icon": "",
              message: _vm.$t("automation.executionPrivacyPublic"),
            },
          })
        : _c("div", { staticClass: "lines" }, [
            _c("div", { staticClass: "subtitle" }, [
              _vm._v(_vm._s(_vm.$t("message.visibleAgents"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "agents" },
              [
                _vm._l(_vm.cloneUserIds, function (id) {
                  return _c(
                    "div",
                    { key: id, staticClass: "agent" },
                    [
                      _c("Avatar", {
                        staticClass: "mr-2 privacy-avatar",
                        attrs: {
                          size: 50,
                          src: _vm.getUser(id)
                            ? _vm.getUser(id).gravatar
                            : undefined,
                          username: _vm.getUser(id)
                            ? _vm.getUser(id).name
                            : "N/A",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{ followCursor: true, placement: 'bottom-end' }",
                          },
                        ],
                        staticClass: "delete-icon",
                        attrs: {
                          content: _vm.getUser(id)
                            ? _vm.getUser(id).name
                            : "N/A",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.deleteAgent(id)
                          },
                        },
                      }),
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "add-btn",
                      on: { click: _vm.openAgentModal },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons",
                          staticStyle: {
                            color: "#696a6b",
                            "padding-right": "2px",
                          },
                        },
                        [_vm._v(" add ")]
                      ),
                    ]
                  ),
                ]),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "subtitle" }, [
              _vm._v(_vm._s(_vm.$t("message.visibleDepartments"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "agents" },
              [
                _vm._l(_vm.cloneDepartmentIds, function (id) {
                  return _c(
                    "div",
                    { key: id, staticClass: "agent" },
                    [
                      _c("Avatar", {
                        staticClass: "mr-2 privacy-avatar",
                        attrs: {
                          size: 50,
                          src: undefined,
                          username: _vm.getDepartmentTitle(
                            _vm.getDepartment(id)
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{ followCursor: true, placement: 'bottom-end' }",
                          },
                        ],
                        staticClass: "delete-icon",
                        attrs: {
                          content: _vm.getDepartmentTitle(
                            _vm.getDepartment(id)
                          ),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.deleteDepartment(id)
                          },
                        },
                      }),
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "add-btn",
                      on: { click: _vm.openDepartmentModal },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons",
                          staticStyle: {
                            color: "#696a6b",
                            "padding-right": "2px",
                          },
                        },
                        [_vm._v(" add ")]
                      ),
                    ]
                  ),
                ]),
              ],
              2
            ),
          ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "section-buttons" },
        [
          _c(
            "a-button",
            {
              staticClass: "privacy-button",
              attrs: { type: "primary" },
              on: { click: _vm.openAgentModal },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("message.editAgentVisibility")) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-button",
            {
              staticClass: "privacy-button",
              attrs: { type: "primary" },
              on: { click: _vm.openDepartmentModal },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("message.editDepartmentVisibility")) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          !_vm.getIsPublic()
            ? _c(
                "a-button",
                {
                  staticClass: "privacy-button",
                  attrs: { type: "danger" },
                  on: { click: _vm.makePublic },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("automation.makePublicExecution")) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.visibleAgentModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("message.selectAgent"),
                "show-footer": false,
              },
              on: {
                cancel: function ($event) {
                  _vm.visibleAgentModal = false
                },
              },
            },
            [
              _c("div", { staticClass: "pf-main" }, [
                _c("div", { staticClass: "pr-search" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchText,
                        expression: "searchText",
                      },
                    ],
                    attrs: {
                      placeholder: _vm.$t("message.searchRepresentative"),
                    },
                    domProps: { value: _vm.searchText },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.searchText = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "material-icons mx-2 pr-icon" }, [
                    _vm._v(" search "),
                  ]),
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pr-items pr-item-wrapper" },
                  _vm._l(_vm.getFilteredUsers(), function (agent) {
                    return _c(
                      "div",
                      {
                        key: agent._id,
                        staticClass: "pr-item",
                        on: {
                          click: function ($event) {
                            return _vm.toggleAgent(agent._id)
                          },
                        },
                      },
                      [
                        _c("a-checkbox", {
                          staticClass: "segment-checkbox",
                          attrs: {
                            checked: _vm.cloneUserIds.includes(agent._id),
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "user-data-wrapper" }, [
                          _c(
                            "div",
                            { staticClass: "user-data" },
                            [
                              _c("Avatar", {
                                staticClass: "mr-2 privacy-avatar",
                                attrs: {
                                  size: 30,
                                  src: agent.gravatar,
                                  username: agent.name,
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "metas" }, [
                                _c("div", { staticClass: "pr-item-name" }, [
                                  _vm._v(_vm._s(agent.name)),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.getAgentDepartmentNames(agent)
                                      ) +
                                      "\n                                    "
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "pr-item-status",
                              attrs: {
                                "data-online":
                                  _vm.$_.get(_vm.user, "_id") === agent._id
                                    ? true
                                    : agent.isOnline,
                                "data-status": agent.status.toLowerCase(),
                              },
                            },
                            [
                              _c("div", {
                                staticClass: "pr-item-status-circle",
                              }),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(agent.status) +
                                  "\n                            "
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-footer-actions" },
                [
                  _c(
                    "a-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.visibleAgentModal = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.cancelText")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      staticClass: "pr-confirm-btn",
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSave },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("message.save")) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.visibleDepartmentModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("message.selectDepartment"),
                "show-footer": false,
              },
              on: {
                cancel: function ($event) {
                  _vm.visibleDepartmentModal = false
                },
              },
            },
            [
              _c("div", { staticClass: "pf-main" }, [
                _c("div", { staticClass: "pr-search" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchText,
                        expression: "searchText",
                      },
                    ],
                    attrs: {
                      placeholder: _vm.$t("message.searchRepresentative"),
                    },
                    domProps: { value: _vm.searchText },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.searchText = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "material-icons mx-2 pr-icon" }, [
                    _vm._v(" search "),
                  ]),
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pr-items pr-item-wrapper" },
                  _vm._l(_vm.getFilteredDepartments(), function (item) {
                    return _c(
                      "div",
                      {
                        key: item._id,
                        staticClass: "pr-item",
                        on: {
                          click: function ($event) {
                            return _vm.toogleDepartment(item._id)
                          },
                        },
                      },
                      [
                        _c("a-checkbox", {
                          staticClass: "segment-checkbox",
                          attrs: {
                            checked: _vm.cloneDepartmentIds.includes(item._id),
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "user-data-wrapper" }, [
                          _c(
                            "div",
                            { staticClass: "user-data" },
                            [
                              _c("Avatar", {
                                staticClass: "mr-2 privacy-avatar",
                                attrs: {
                                  size: 30,
                                  src: undefined,
                                  username:
                                    item.languageContent[_vm.$i18n.locale].name,
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "metas" }, [
                                _c("div", { staticClass: "pr-item-name" }, [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        item.languageContent[_vm.$i18n.locale]
                                          .name
                                      ) +
                                      "\n                                    "
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "pr-item-status" }, [
                            _c(
                              "div",
                              { staticClass: "avatar-group" },
                              [
                                _vm._l(
                                  _vm.getDepartmentUsers(item._id, 2),
                                  function (user) {
                                    return _c("Avatar", {
                                      key: user._id,
                                      staticClass: "avatar-wrapper",
                                      attrs: {
                                        size: 30,
                                        src: user.gravatar,
                                        username: user.name,
                                      },
                                    })
                                  }
                                ),
                                _vm._v(" "),
                                _vm.getDepartmentUsers(item._id).length > 2
                                  ? _c(
                                      "div",
                                      { staticClass: "extra avatar-wrapper" },
                                      [
                                        _vm._v(
                                          "\n                                        +" +
                                            _vm._s(
                                              _vm.getDepartmentUsers(
                                                item._id,
                                                2
                                              ).length - 2
                                            ) +
                                            "\n                                    "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]),
                        ]),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-footer-actions" },
                [
                  _c(
                    "a-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.visibleDepartmentModal = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.cancelText")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      staticClass: "pr-confirm-btn",
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSave },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("message.save")) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }